import { motion } from 'framer-motion';

const credentials = [
  {
    icon: 'ri-truck-line',
    type: 'DOT NUMBER',
    number: '4476843',
    description: 'US Department of Transportation',
  },
  {
    icon: 'ri-shield-star-line',
    type: 'MC NUMBER',
    number: '1767623',
    description: 'Motor Carrier Authority',
  },
  {
    icon: 'ri-file-shield-2-line',
    type: 'BUSINESS LICENSE',
    number: 'NV20253377515',
    description: 'Nevada State License',
  },
];

export default function Credentials() {
  return (
    <section className="py-24 bg-dark-800 relative">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-orbitron text-5xl font-bold text-white mb-4">
            LICENSED &amp; <span className="text-electric-blue">CERTIFIED</span>
          </h2>
          <p className="font-inter text-white/60 text-lg">
            Fully authorized and insured for your peace of mind
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {credentials.map((cred, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
              className="group"
            >
              <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-3xl p-8 hover:bg-white/10 hover:border-electric-blue/50 transition-all duration-300 hover:shadow-2xl hover:shadow-electric-blue/20 h-full">
                <div className="mb-6 flex justify-center">
                  <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-electric-blue to-electric-cyan flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <i className={`${cred.icon} text-4xl text-dark-900 w-10 h-10 flex items-center justify-center`}></i>
                  </div>
                </div>

                <div className="font-orbitron text-xs text-electric-blue tracking-widest mb-3 text-center">
                  {cred.type}
                </div>

                <div className="font-orbitron text-3xl font-bold text-white mb-4 text-center">
                  {cred.number}
                </div>

                <div className="font-inter text-white/60 text-sm text-center mb-6">
                  {cred.description}
                </div>

                <div className="flex items-center justify-center space-x-2 pt-4 border-t border-white/10">
                  <i className="ri-checkbox-circle-fill text-green-400 text-xl w-5 h-5 flex items-center justify-center"></i>
                  <span className="font-inter text-green-400 text-sm font-medium">Verified</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
